<div>
    <dynamic-form [label]="label" [noSubmit]="true"  [group]="formGroup" (cancelChange)="cancel()">
        <ng-container class="content">
            <div class="container">
                <div class="page" *ngIf="this.columns && this.columns?.length > 0">
                <kgrid 
                    [label]="label"
                    name="Invoice"
                    [columns]="columns"
                    [areaName]="areaName"
                    [isEdit]="false"
                    [isDelete]="false"
                    [isAdd]="false"
                    [isModal]="true"
                    [noToolBar]="true"
                    [gridViewData]="currentData"
                    [filters]="filters"
                    (onDataStateChanged)="onDataStateChanged($event)"
                    [pagingSize]="10">
                </kgrid>
            </div>
        </div>
    </ng-container> 
    </dynamic-form>
</div>